import React, { useState, useEffect, } from 'react';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { connect } from 'react-redux';
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import { searchResultApi } from "../../const";
import common from "../../resources/js/common/common";
import arrow from '../../resources/icons/arw.svg';
import { ImageButton } from '../atoms/imageButton';
import { GolfSoloWeeksDate } from '../molecules/golfSoloWeeksDate';

const SoloVacancyInfoContainerCallender = (props) => {
    const {
        startTime,
        soloCourse,
        setSoloCourse,
        onClickMoveWeeks,
        soloKaiinken,
        golfSoloSearchData,
        setGolfSoloSearchData,
        vacancyWeek,
        vacancyInfo,
        getCalendarStartDate,
        onClickOpenPlanCalendarWindow
    } = props;

    const { getHoliday } = GetPublicHoliday();

    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [nextFlag, setNextFlag] = useState(false);
    const [NotSearch, setNotSearch] = useState(false)


    const history = useHistory();
    let twoWeeks = [];

    // モバイル版のカレンダー切替
    const onClickNextView = () => {
        setNextFlag(!nextFlag);
    }

    const onClickPlan = (planId, planName) => {

        // 2週間カレンダーのスタート日
        let startDate2w = getCalendarStartDate();
        let startDate = new Date(startDate2w);
        startDate.setMonth(startDate.getMonth() - 1);
        startDate.setDate(25);
        let nowDate = new Date();
        nowDate.setHours(0);
        nowDate.setMinutes(0);
        nowDate.setSeconds(0);
        nowDate.setMilliseconds(0);

        if ((startDate2w.getFullYear() === nowDate.getFullYear()
            && startDate2w.getMonth() === nowDate.getMonth()) || nowDate >= startDate) {
            startDate.setFullYear(nowDate.getFullYear());
            startDate.setMonth(nowDate.getMonth());
            startDate.setDate(nowDate.getDate() + 3);
        }
        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`


        const req = {
            playDate: `${y}-${m}-${d}`,
            golfCourseId: golfSoloSearchData.golfCourseId,
            membershipAuthID: golfSoloSearchData.memberShipAuth,
            planId: planId,
            planInfo: [{planId: planId, planName: planName}],
            searchType: 1,
            kaiinKind:golfSoloSearchData.kaiinKind,
        }

        // リクエスト情報の格納
        let newGolfSoloSearchData = {
            ...golfSoloSearchData,
            planId: planId,
            planName: planName
        }
        setGolfSoloSearchData(newGolfSoloSearchData);
        onClickOpenPlanCalendarWindow(req, planName, startDate2w);
    }

    // 〇△を押下した場合の処理
    const toList = (planId, planName, reqDate) => {
        let date = new Date(reqDate);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // リクエスト情報の格納
        let newGolfSoloSearchData = {
            ...golfSoloSearchData,
            playDate: `${y}-${m}-${d}`,
            planId: planId,
            planName: planName
        }
        setGolfSoloSearchData(newGolfSoloSearchData);

        // 画面遷移
        history.push("/reserve/golf/soloStartTime");
    }

    return (
        <div className='soloSearch_calendarContainer'>
            <div className='soloSearch_calendarArea'>
                <div className='soloSearch_calendarTitle'>
                    <ImageButton btnClass={"arrowBtn"} imgClass={"arrowBack"} onClick={() => onClickMoveWeeks("back")} image={arrow} />
                    <div>{props.MonthHead}</div>
                    <ImageButton btnClass={"arrowBtn"} imgClass={"arrowNext"} onClick={() => onClickMoveWeeks("next")} image={arrow} />
                </div>
                {isWideTablet ?
                    <div className={vacancyInfo.length > 3 ? 'soloSearch_table2' : 'soloSearch_table1'}>
                        {vacancyInfo !== undefined && vacancyWeek !== undefined ? vacancyInfo.length !== 0 && vacancyWeek.length !== 0 ?
                            <GolfSoloWeeksDate
                                data={vacancyWeek.filter((value, index) => index < 7)}
                                data2={vacancyInfo.map(value => {
                                    let newObj = { ...value };
                                    newObj.vacancyList = newObj.vacancyList.filter((vacancy, index) => index < 7);
                                    return newObj;
                                })}
                                onClick={toList}
                                onClickPlan={onClickPlan}
                                responsiveFlg={true}
                            />
                            : null : null
                        }
                    </div> :
                    <div className={vacancyInfo.length > 4 ? 'soloSearch_table2' : 'soloSearch_table1'}>
                        {vacancyInfo !== undefined && vacancyWeek !== undefined ? vacancyInfo.length !== 0 && vacancyWeek.length !== 0 ?
                            <GolfSoloWeeksDate
                                data={vacancyWeek}
                                data2={vacancyInfo}
                                onClick={toList}
                                onClickPlan={onClickPlan}
                                responsiveFlg={false}
                            />
                            : null : null
                        }
                    </div>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        startTime: state.startTime,
        soloCourse: state.soloCourse,
        soloKaiinken: state.soloKaiinken,
        golfSoloSearchData: state.golfSoloSearchData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSoloCourse: (item) => {
            dispatch({ type: "SOLO_COURSE", payload: { soloCourse: item } })
        },
        setGolfSoloSearchData: (item) => {
            dispatch({ type: "GOLF_SOLO_SEARCH_DATA", payload: { golfSoloSearchData: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SoloVacancyInfoContainerCallender);